import React from 'react';

import SingleParagraphContents from './SingleParagraphContents.jsx';
import TwoParagraphContents from './TwoParagraphContents.jsx';

export default class SimpleTextBox extends React.Component {

  render() {
    var contents = this.getContents(this.props.page);

    return (
      <div className="SimpleTextBox row">
        <div className="col-xs-16 col-md-12 col-md-push-2" data-scroll-item-once>
          {contents}
        </div>
      </div>
    );
  }

  pageUsesDoubleParagraph(page) {
    switch (page) {
      case 'contact':
      case 'people':
        return true;
      default:
        return false;
    }
  }

  getContents(page) {
    if (this.pageUsesDoubleParagraph(page) === true) {
      return (
        <TwoParagraphContents page={this.props.page} />
      );
    }

    return (
      <SingleParagraphContents page={this.props.page} />
    );
  }

};
